import {Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AbstractGameComponent} from "../../game/abstract-game.component";
import { MatIcon } from '@angular/material/icon';
import { ScoreBoardComponent } from '../score-board/score-board.component';
import { LastPlaySectionComponent } from '../last-play-section/last-play-section.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-top-section',
    templateUrl: './top-section.component.html',
    styleUrls: ['./top-section.component.scss'],
    imports: [MatIcon, ScoreBoardComponent, LastPlaySectionComponent, TranslocoModule]
})
export class TopSectionComponent extends AbstractGameComponent implements OnInit{
  showLastPlaySection = true;
  // lastQuarter = false;
  private destroyRef = inject(DestroyRef);
  private hideHeaderForRoutes: string[] = [
    '/game-play/run',
    '/game-play/complete-pass',
    '/game-play/incomplete-pass',
    '/game-play/interception',
    '/game-play/qb-sack',
    '/game-play/punt',
    '/game-play/fg-attempt',
    '/game-play/pre-snap-penalty',
    '/game-play/kickoff-selection',
    '/game-play/kickoff',
    '/game-play/onside-kick'
  ];

  @Input() backButtonEnabled = true

  ngOnInit(): void {
    this.checkUrlAndUpdateHeader(this.router.url);
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.checkUrlAndUpdateHeader(this.router.url);
    });
  }

  private checkUrlAndUpdateHeader(currentUrl: string): void {
    this.showLastPlaySection = !this.hideHeaderForRoutes.includes(currentUrl);
  }
}
